import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';

import { Icon } from '@components/base';

import { TextField } from './TextField';

export type PasswordFieldProps = Omit<
  TextFieldProps,
  'children' | 'select' | 'SelectProps' | 'type'
>;

export const PasswordField: FC<PasswordFieldProps> = ({
  autoComplete = 'current-password',
  label,
  required = true,
  InputProps,
  ...rest
}) => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      autoComplete={autoComplete}
      label={label ?? t('password')}
      required={required}
      type={showPassword ? 'text' : 'password'}
      {...rest}
      slotProps={{
        input: {
          ...InputProps,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                edge='end'
                onClick={() => setShowPassword(!showPassword)}
                size='small'
                title={t('showHidePassword', { context: showPassword ? 'show' : 'hide' })}
              >
                <Icon fontSize='small' name={showPassword ? 'visibilityOff' : 'visibility'} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
